$(function() {
  const ua = navigator.userAgent
  const os = navigator.platform
  const bs = window.navigator.userAgent.toLowerCase()
  const body = document.getElementsByTagName('body')

  if (ua.indexOf('iPhone') != -1 || ua.indexOf('iPod') != -1) {
    body[0].classList.add('ua-sp', 'ua-iphone')
  } else if (ua.indexOf('iPad') != -1 || (ua.indexOf('Macintosh') > -1 && 'ontouchend' in document)) {
    body[0].classList.add('ua-tb', 'ua-ipad')
  } else if (ua.indexOf('Android') != -1) {
    if (ua.indexOf('Mobile') != -1) {
      body[0].classList.add('ua-sp', 'ua-android')
    } else {
      body[0].classList.add('ua-tb', 'ua-android')
    }
  } else if (os.indexOf('Win') != -1) {
    body[0].classList.add('ua-pc', 'ua-win')
  } else {
    body[0].classList.add('ua-pc', 'ua-not-win')
  }

  if (bs.indexOf('msie') != -1 || bs.indexOf('trident') != -1) {
    body[0].classList.add('ua-ie')
  } else if (bs.indexOf('edge') != -1) {
    body[0].classList.add('ua-edge')
  } else if (bs.indexOf('chrome') != -1) {
    body[0].classList.add('ua-chrome')
  } else if (bs.indexOf('safari') != -1) {
    body[0].classList.add('ua-safari')
  } else if (bs.indexOf('firefox') != -1) {
    body[0].classList.add('ua-firefox')
  } else if (bs.indexOf('opera') != -1) {
    body[0].classList.add('ua-opera')
  } else {
    body[0].classList.add('ua-other-browser')
  }

  const win7 = ua.indexOf('Windows NT 6.1') != -1
  if (win7) {
    document.getElementsByTagName('body')[0].classList.add('ua-win7')
  }
})

$(function() {
  const ua = navigator.userAgent
  if (ua.indexOf('iPhone') != -1 || (ua.indexOf('Android') != -1 && ua.indexOf('Mobile') != -1)) {
    $('a[href^="tel:"]').css('pointer-events', 'auto')
  } else if (ua.indexOf('iPad') != -1 || ua.indexOf('Android') != -1 || (ua.indexOf('Macintosh') > -1 && 'ontouchend' in document)) {
    $('a[href^="tel:"]').css('pointer-events', 'none')
  } else {
    $('a:not([data-not-hover]),button:not([data-not-hover]),input:not([data-not-hover]),label:not([data-not-hover])').addClass('is-state-hover')
    $('a[href^="tel:"]').css('pointer-events', 'none')
    if ($('.is-state-hover').length) {
      $('.is-state-hover').hover(
        function() {
          $(this).addClass('is-hover')
        },
        function() {
          $(this).removeClass('is-hover')
        }
      )
    }
  }
})
